import RHFInputNumber from "./rhf-input-number.component";

export default RHFInputNumber;
